import { Component, OnDestroy, OnInit } from '@angular/core';
import { Language, LanguageList } from '../../model/language.model';
import { DictionnaryService } from '../../service/dictionnary.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { LanguageService } from '../../service/language.service';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'languages-translate',
    templateUrl: './languages-translate.component.html',
    styleUrls: ['./languages-translate.component.scss']
})
export class LanguagesTranslateComponent implements OnInit, OnDestroy {

    availableLangs: { code: any, label: any }[] = [];
    activeLang: { code: any, label: any } = null;
    languages: Language[] = [];

    _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        public dictionnaryService: DictionnaryService,
        public translateService: TranslateService,
        public languageService: LanguageService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.availableLangs = this.dictionnaryService.getTranslateLanguage().filter((lang) => environment.urls.languages.find((l) => l === lang.code));
        this.activeLang = this.availableLangs.find((lang) => lang.code === this.translateService.getDefaultLang());
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Set the active lang
     *
     * @param language: Language
     */
    setActiveLang(language: { code: any, label: any }): void {
        this.activeLang = language;
        const _lang = language.code;
        this.languageService.setCurrentLanguage(_lang);
        this.translateService.setDefaultLang(_lang);
        this.translateService.use(_lang);
        this.dictionnaryService.getDictionnary2(_lang)
            .subscribe(res => {
                if (res) {
                    this.translateService.setTranslation(_lang, res);
                }
            });
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
}
